// 英语
export default {
  language: "English",
  desc: "Who are we?",
  myagency: "MY Agency",
  joinAgency: "Join Agency",
  youNeedFaceVerify: "Please take a video showing your face",
  writeGuildId: "Please enter the guild ID",
  checkAgreement: "Please check the agreement",
  edit: "Edit",
  easyEarn: "Easily earn over",
  month: "+ per month",
  applyHost: "Apply to become a",
  voiceHost: "voice chat room host",
  oneHost: "1v1 host",
  ultraFast: "Ultra-Fast Host Verification",
  onePhone: "Start Earning with Just One Phone",
  "complete.personal.information": "Complete Personal Information",
  "change.avatar": "Change Avatar",
  "fill.signature": "Fill in Personal Signature",
  "upload.photo.wall": "Upload 3 photos to the photo wall",
  "profile.private.photos": "Profile & private photos",
  MaterialsCompleted: "Materials have been completed",
  MaterialsUnfinished: "You have unfinished materials",
  "enter.guildId": "Enter the guild ID you want to join",
  "facial.verification": "Facial Verification",
  "verification.completed": "Verification has been completed",
  "take.video.face": "Take a video showing your face",
  reviewing: "Reviewing",
  "under.review": "Under Review...",
  "wait.review": "Please wait patiently for approval",
  "applicant.rejected": "Applicant Rejected",
  "resubmit.desc": "Application rejected. You may resubmit.",
  "no.resubmit.desc": "Application rejected. Cannot resubmit.",
  resubmit: "Resubmit for Review",
  "reason.for.rejection": "Reason for Rejection:",
  "last.3.photos": "Host verification requires at least 3 photos",
  vertify: "Verify",
  submit: "Submit",
  agreeto: "Agree to the ",
  achorgreement: "Anchor Settling-in Agreement",
  "streamer.agreement": "Streamer Agreement",
  'upload.profile':'Upload your profile picture',
  // 我的工会
  leader: "Leader",
  myAgencyIncome: "My Agency Income",
  totalStreamers: "Total Streamers",
  diamondIncome: "Diamond Income",
  charmIncome: "Charm Income",
  hostList: "Host List",
  enterUID: "Enter UID",
  no: "No.",
  hostInfo: "Host Info",
  // 邀请页
  get: "Get",
  "when.your.invite.registers": "when your invite registers ",
  "commission.y.i": `commission on your invite's spending `,
  "within.d.r": "within 30 days after registration ",
  "when.y.j": "when your invite joins the ",
  agency: "agency",
  "when.y.c": "when your invite completes a ",
  "valid.w.s": "valid week of streaming ",
  "commission.i": `commission on your invite’s `,
  "income.d.s": "income for 14 days after successful verification ",
  "get.i.r": "Get 8% commission on your invite’s coin purchases for 30 days after registration",
  "when.b.a": "when your invite becomes a ",
  "verified.s": "verified streamer and streams in Work Mode for at least 3 days during their first week",
  "rewards.claimed": "Rewards Claimed",
  "view.detail": "View Detail",
  withdraw: "Withdraw",
  "copy.c": "Copy your invite code",
  "copy.a.c": "Copy your Agency ID",
  "copy.f.c": "Copy friend's Agency ID",
  copy: "Copy",
  "your.f.l": "Your friends open or download Sallo via the link",
  "your.f.s": "Your friends enter your invite code and submit",
  "Your.f.f.s":
    "Your friendFriend fills in your Agency ID when applying for agency entrys enter your invite code and submit",
  "f.f.a": "Fill in friend's Agency ID to apply",
  "the.a": "The Agency approves your application",
  "your.invites": "Your Invites",
  "user.info": "User Info",
  contribution: "Contribution",
  date: "Date",
  "no.messages.yet": "No messages yet",
  "share.invite.link": "Share Invite Link",
  "invite.users": "Invite Users",
  "invite.host": "Invite Host",
  // 被邀请页
  earn: "Earn",
  "easily.m": " Easily Every Month",
  "voice.c": "Voice chat live streaming, 1v1 calls/video",
  "fast.s": "Fast streamer verification — start earning with just your phone",
  "claim.f": "Claim Free Premium Subscription Time, Tokens, and Gifts",
  "lots.o": "Lots of streamer types and deep interactions",
  "open.sallo": "Open Sallo",
  // 主播中心
  "host.center": "Host Center",
  "charm.Income": "Charm Income",
  "upgrade.to": "Upgrade to",
  "still.need": "Still need",
  "to.next.level": "to next level",
  today: "Today",
  week: "Week",
  "my.questions": "My Questions",
  "online.data": "Online Data",
  "availability.duration": "Availability Duration",
  "in-room.duration": "In-Room Duration",
  "call.data": "Call Data",
  matches: "Matches",
  calls: "Calls",
  "success.rate": "Success Rate",
  "income.data": "Income Data",
  charm: "Charm",
  "gift.income": "Gift Income",
  "call.income": "Call Income",
  overview: "Overview",
  "total.income": "Total Income",
  "average.duration": "Average Duration",
  "pm.income": "PM Income",
  "task.income": "Task Income",
  // 任务中心
  tasks: "Tasks",
  "claimed.coins": "Claimed coins",
  "claimed.diamonds": "Claimed diamonds",
  "diamond.Withdrawal.rules": "Diamond Withdrawal Rules",
  "diamond.Withdrawal.rules.content": "5,000 diamonds = 1 US dollar",
  "withdrawal.applications:": "Withdrawal applications:",
  "withdrawal.applications.content": "Every Monday & Tuesday",
  "withdrawal.received": "Withdrawal received",
  "withdrawal.received.content": "Every Wednesday",

  "message.example": "Message Example:",
  note: "Note:",
  "message.example.content":
    'Pls make your texts no less than 30 characters to get the reward. The word "Hey" counts as 3 characters.Don\'t copy the example word for word. Show your own charm and style~',
  step1: "Step1",
  "find.a.user": "Find a user with Newbie Mark, he's a totally new user in the platform",
  step2: "Step2",
  "message.him":
    "Message him and guide him to make first top up. After first top up, there's a special necklace in his bag.",
  Step3: "Step3",
  "ask.him": "Ask him to send the the necklace in room or in message.",
  "in.room": "In room",
  "to.find": "to find the necklace",
  "in.message": "In message",
  next: "Next",

  "invite.a.new.host": "Invite a new host",
  "invite.a.new.user": "Invite a new user",
  go: "Go",
  "invite.host.and": "Invite hosts and get generous rewards! Invite your friends to join now~",
  "Invite.Rewards": "Invite Rewards:",

  "Get.1000": "Get 1000 diamonds immediately once your friend gets verified as a host.",
  "Get.2500": "Get 2500 diamonds when your friend has streamed for a full week (12 hours per week).",
  "Get.5": "Get 5% commission on your friend's income for 14 days after successful verification.",

  "You.Can.Check": 'You can check the rewards in "Invite&Earn" in your personal page',

  "Invite.user.and": "Invite your user/boss and get generous rewards! Top-ups here are super cheap~",
  "Get.2500.2": "Get 2500 diamonds immediately when your user/boss registers.",
  "Get.5.2": "Get 5% commission on your user/boss spending within 30 days after registeration.",

  regular: "Regular",
  diamonds: "Diamonds",
  "first.recharge": "First recharge",
  "first.t": "First time sending gifts",
  "first.p": "First PM",
  "first.v": "First video call",
  "following.friends": "Following friends*3",
  "speaking.i": "Speaking in a voice chat room",
  completed: "Completed",
  incomplete: "Incomplete",
  "new.h": "New Host Task",
  "ends.in": "Ends in",
  days: "days",
  "daily.tasks": "Daily Tasks",
  "weekly.tasks": "Weekly Tasks",
  "monthly.tasks": "Monthly Tasks",
  // 账号管理
  manage: "Manage",
  "submitted.successfully": "Submitted successfully",
  "please.name": "Please enter the GCash Registered Full Name.",
  "please.number": "Please enter the GCash Registered Phone Number.",
  "please.content": "Please read and understand this content.",
  "please.trc-20": "Please enter the TRC-20.",
  "please.address": "Please enter the TRC20 Address.",
  "please.understand": "Please read and understand this content.",
  "please.format": "Please confirm that this network is in the TRC-20 format.",
  fee: "Fee:",
  "no.message": "No messages yet",
  "add.bank": "Add bank card",
  country: "Country",
  confirm: "Confirm",
  "bind.account": "Bind Account",
  "gcash.name": "GCash Registered Full Name",
  "gcash.number": "GCash Registered Phone Number",
  "gcash.number.placeholder": "Enter the 11-digit mobile number starting with 09，e.g., 0917 123 4567",
  "important.note": "Important Note",
  "please.ensure":
    "Please ensure the name and phone number strictly matches your Gcash account information, otherwise the withdrawal will fail.",
  "is.correct": "I have confirmed that all information is correct.",
  "transfer.network": "Transfer Network",
  "is.trc": "I have confirmed the network is TRC-20",
  "trc.address": "TRC20 Address",
  "trc.address.placeholder": 'Paste TRC-20 address (Starts with "T")',
  "your.funds":
    "Ensure the selected currency and network strictly match your exchange details. Any incorrect transaction may lead to the permanent loss of your funds.",
  "above.risks": "I have read and understood the above risks.",
  "details.carefully":
    "Please ensure the name strictly matches your bank account information, otherwise the withdrawal will fail. Please double-check your bank details carefully.",
  // 提现
  withdrawal: "Withdrawal",
  quantity: "Quantity",
  "please.amount": "Please enter the Amount.",
  "please.diamond": "Please enter the correct diamond.",
  "minimum.withdrawal.25k": "Minimum withdrawal of 25k.",
  "minimum.withdrawal.35k": "Minimum withdrawal of 35k.",
  "diamond.withdraw": "Diamond withdraw",
  "withdrawal.usd": "Withdrawal:",
  "the.credited": "The credited amount will be based on the local currency",
  "exchange.rate": "exchange rate at the time of crediting.",
  "minimum.withdrawal.5": "5K Diamonds = 1 USD. Minimum withdrawal of $5.",
  "minimum.withdrawal.7": "5K Diamonds = 1 USD. Minimum withdrawal of $7.",
  "withdrawals.must": "Withdrawals must be in multiples of 1k.",
  cashable: "Cashable",
  "amount.usd": "Amount(USD)",
  amount: "Amount",
  all: "ALL",
  "transacton.fee": "Transacton Fee:",
  "withdraw.to": "Withdraw to",
  "manage.account": "Manage Account",
  "my-account": "My Account",
  account: "Account",
  "agency.account": "Agency Account",
  "the.last": "The last settlement failed. Please verify your information.",
  "agency.owner": "Agency Owner",
  "withdrawals.will": `Withdrawals will be transferred to the Agency's consolidated account.`,
  "fee.usd": "Fee(USD)",
  usd: "USD",
  "will.reduce": "This will reduce",
  "enter.amound.1": "Min. withdrawal $1",
  "enter.amound.7": "Min. withdrawal $7",
  "enter.dimond": "Enter dimond amount",
  "in.diamond": "in Diamond Net Earnings",
  "diamond.net":
    "Diamond Net Earnings refer to income generated specifically from private messages, matches, video calls, and dimond gifts(This does not include task rewards,charm income,and other bonuses).Rewards will be issued to the host's account the following Monday.",
  "upgrader.to": "Upgrader to",
  directions: "Directions",
  charms: "charms",
  "task.calculation":
    "Only the charms coming from new users（Registered within 30 days） are included in the task statistics; the charms coming from existing users and hosts are not included in the task calculation.",
  claimed: "Claimed",
  obtained: "Obtained",
  "add.withdrawal": "Add Withdrawal Account",
  supports: "Supports GCash and USDT",
  "invitation.copy.success": "Your link has been copied",

  reward: "Reward :",
  "diamonds.pre": "diamonds ($1) per valid host. More invites, more rewards. No limit.",

  "valid.host": "Valid host :",
  "certified.and.earns": "Certified and earns",
  "within.7.days": "within 7 days.",
  "please.select": "Please select an MP3 music file",
  "file.size": "Please select a music file between 512KB and 8MB",
  "daily.music.limit": "Daily music import limit reached",
  "music.limit": "Music import limit reached",
  "import.music": "Import Music",
  "mobile.import": "Mobile lmport",
  "connected.wifi": "· Make sure your phone is connected to WiFi",
  "tap.below": '· Tap the "lmport" button below',
  "between.512K.8M": "· Please select an audio file (mp3) between 512K and 8M",
  "submit.import": "· Submit to import",
  import: "Import",
  "import.failed": "Import Failed",
  "import.success": "Import Success",
  "network.delay": "Network delay",
  importing: "Importing...",
  "song.name": "Song Name",
  status: "Status",
  success: "Success",
  failed: "Failed",
  close: "Close",
  "please.do.not.close":
    "Please do not close the page until the import is complete. Closing it midway may cause the import to fail.",
  "content.fail": "Content is being imported. Closing the page will cause the import to fail.",
  cancel: "Cancel",
  "Payment.failed": "Payment failed",
  "sensitive.info": "Sensitive info",
  "matched.calls": "Matched calls",
  "card.calls": "Card calls",
  "today.answered": "Today answered:",
  "still.to.answer": "Still to answer:",
  "First.peak.period": "First peak period",
  "9.00": "09:00–12:00 Beijing Time (UTC+8)",
  Or: "or",
  "21.00": "21:00–0:00 Eastern Time (UTC-4)",
  "Second.peak.period": "Second peak period",
  "14.00": "2:00–5:00 Beijing Time (UTC+8)",
  "14.00.2": "14:00–17:00 Eastern Time (UTC-4)",
};
